import { FileUploader } from 'common/file-uploader';
import { ImagePreview } from 'common/image-preview';
import {
  vaultCoverSupportedExtensions,
  mbVaultCoverMaxSize,
} from 'config/constants';
import React, { useState } from 'react';
import styles from './vault-cover.module.scss';

type VaultCoverProps = {
  setIsLoading: Function;
  // Called with the signed id and the local preview URL, so callers that show
  // the cover elsewhere (e.g. the create-vault summary) don't have to re-read
  // the file.
  setImage: (signedId: string | undefined, previewUrl: string | null) => void;
};

const VaultCover: React.FC<VaultCoverProps> = ({ setIsLoading, setImage }) => {
  const [imagePreview, setPreview] = useState<string | null>(null);

  const handleFileUpload = ({ url, signedId }: FileResponseType) => {
    setIsLoading(false);
    setPreview(url);
    setImage(signedId, url);
  };

  const handleRemovePreview = () => {
    setPreview(null);
    setImage(undefined, null);
  };

  return (
    <div className={styles.titleAndCover}>
      <p className="text__body__semi__bold__medium__gray800">
        Vault cover photo
        <span className="text__body__regular__medium__gray500">
          {' '}
          (Optional)
        </span>
      </p>

      <div className={styles.cover}>
        {!imagePreview ? (
          <FileUploader
            className={styles.fileUploader}
            supportedExtensions={vaultCoverSupportedExtensions}
            maxFileSizeInMb={mbVaultCoverMaxSize}
            uploadingMessage="Uploading cover..."
            onSuccess={handleFileUpload}
            onLoading={() => setIsLoading(true)}
            onError={() => setIsLoading(false)}
            onCancel={() => setIsLoading(false)}
          />
        ) : (
          <ImagePreview
            imageLocation={imagePreview}
            removePreview={() => handleRemovePreview()}
          />
        )}
      </div>
    </div>
  );
};

export { VaultCover };
